// Settings → Billing card form (settings/billing/_credit_card_form). Stripe Elements mounts the card
// iframe into #card-element; on submit we tokenize and POST the token id as `stripeToken`.
//
// ★ Stripe.js (https://js.stripe.com/v3/) is a THIRD-PARTY script and some browsers refuse it —
// Firefox strict tracking protection, privacy/ad-blocking extensions, locked-down profiles. When
// that happens `Stripe` is undefined. Until 2026-10-18 this callback threw right there, BEFORE
// binding its submit handler, so the dealer got an empty card box with a live "Update billing info"
// button: every click native-submitted the form with no token → "An error occurred while updating
// billing information." and no hint why. Eric Johnson (AUTO BAHN MOTORS) hit that 4× on 10-11/10-12
// trying to pay (PostHog: ReferenceError "Stripe is not defined" on every load of the page in his
// Firefox; HB fault 134972457). Contract now: (1) say exactly what is blocked and how to get past it,
// (2) keep the button disabled until the card iframe is actually ready, (3) NEVER let the form leave
// the page without a token — the server has nothing to charge without one.
var STRIPE_BLOCKED_MESSAGE =
  "The secure card form could not load because your browser is blocking js.stripe.com " +
  "(strict tracking protection or a privacy / ad-blocking extension). Allow js.stripe.com for " +
  "app.motorlot.com, or open this page in another browser, then enter your card again.";

var TOKENIZE_FAILED_MESSAGE =
  "We could not reach Stripe to secure your card details. Please check your connection and try again.";

function showCardError(message) {
  var displayError = document.getElementById("card-errors");
  if (displayError) displayError.textContent = message || "";
}

function submitButton(form) {
  return form.querySelector('input[type="submit"], button[type="submit"]');
}

function setSubmitEnabled(form, enabled) {
  var button = submitButton(form);
  if (button) button.disabled = !enabled;
}

function hasToken(form) {
  return !!form.querySelector('input[name="stripeToken"]');
}

// Bound FIRST, before anything that can throw: a submit that carries no token is stopped here no
// matter what state Stripe is in. A programmatic form.submit() (the tokenized path) does not fire
// the submit event, so it is unaffected.
function guardBlindSubmit(form) {
  form.addEventListener("submit", function (event) {
    if (hasToken(form)) return;
    event.preventDefault();
    if (typeof window.Stripe !== "function") showCardError(STRIPE_BLOCKED_MESSAGE);
  });
}

function initBillingCardForm() {
  var form = document.getElementById("payment-form");
  var mount = document.getElementById("card-element");
  if (!form || !mount) return;

  guardBlindSubmit(form);

  // Guard on a present publishable key: a nil key (Stripe secrets absent) must not throw and
  // break the page — the card form simply stays inert.
  var publishableKey = window.gon && gon.stripe_publishable_key;
  if (!publishableKey) return;

  // The script tag is in <head>; if it did not run by now the browser refused it.
  if (typeof window.Stripe !== "function") {
    setSubmitEnabled(form, false);
    showCardError(STRIPE_BLOCKED_MESSAGE);
    return;
  }

  // Held until the card iframe reports ready — a click before that has nothing to tokenize.
  setSubmitEnabled(form, false);

  // Create a Stripe client
  var stripe = Stripe(publishableKey, { locale: "en" });

  // Create an instance of Elements
  var elements = stripe.elements();

  // Custom styling can be passed to options when creating an Element.
  // (Note that this demo uses a wider set of styles than the guide below.)
  var style = {
    base: {
      color: "#32325d",
      lineHeight: "24px",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  };

  // Create an instance of the card Element
  var card = elements.create("card", { style: style });

  // Add an instance of the card Element into the `card-element` <div>
  card.mount("#card-element");

  card.on("ready", function () {
    setSubmitEnabled(form, true);
  });

  // The iframe itself failed to load (network / blocked frame): same guidance as a blocked script.
  card.on("loaderror", function (event) {
    setSubmitEnabled(form, false);
    showCardError((event && event.error && event.error.message) || STRIPE_BLOCKED_MESSAGE);
  });

  // Handle real-time validation errors from the card Element.
  card.addEventListener("change", function (event) {
    showCardError(event.error ? event.error.message : "");
  });

  // Handle form submission
  form.addEventListener("submit", function (event) {
    if (hasToken(form)) return;
    event.preventDefault();
    setSubmitEnabled(form, false);

    stripe
      .createToken(card)
      .then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          showCardError(result.error.message);
          setSubmitEnabled(form, true);
        } else {
          // Send the token to your server
          stripeTokenHandler(form, result.token);
        }
      })
      .catch(function () {
        showCardError(TOKENIZE_FAILED_MESSAGE);
        setSubmitEnabled(form, true);
      });
  });
}

function stripeTokenHandler(form, token) {
  // Insert the token ID into the form so it gets submitted to the server
  var hiddenInput = document.createElement("input");
  hiddenInput.setAttribute("type", "hidden");
  hiddenInput.setAttribute("name", "stripeToken");
  hiddenInput.setAttribute("value", token.id);
  form.appendChild(hiddenInput);

  // Submit the form
  form.submit();
}

document.addEventListener("turbo:load", initBillingCardForm);
